import {
  createConfig,
  getConfigByTypeKey,
  getConfigs,
  updateConfig,
  deleteConfig,
} from "./configurationService";

const TEMPLATE_TYPE = "shared-prompt-template";

const viewScope = [
  "owner",
  "admin",
  "prompt-engineer",
  "clinical-author",
  "demonstrator",
  "viewer",
];
const editScope = ["owner", "admin", "prompt-engineer", "clinical-author"];
const deleteScope = ["owner", "admin", "prompt-engineer", "clinical-author"];

export const sharedTemplateService = {
  createTemplate: async (key, value) => {
    return await createConfig(
      TEMPLATE_TYPE,
      key,
      value,
      null,
      null,
      viewScope,
      editScope,
      deleteScope
    );
  },

  getAllTemplates: async () => {
    return await getConfigs(TEMPLATE_TYPE);
  },

  getTemplate: async (key, throw404 = false) => {
    try {
      return await getConfigByTypeKey(TEMPLATE_TYPE, key);
    } catch (e) {
      if (throw404 && e.response && e.response.status === 404) {
        throw e;
      }
      return null;
    }
  },

  updateTemplate: async (key, templateValue) => {
    const template = await getConfigByTypeKey(TEMPLATE_TYPE, key);
    return await updateConfig(
      template.id,
      TEMPLATE_TYPE,
      template.key,
      templateValue
    );
  },

  deleteTemplate: async (key) => {
    const template = await getConfigByTypeKey(TEMPLATE_TYPE, key);
    return await deleteConfig(template.id);
  },

  duplicateTemplate: async (key) => {
    const template = await getConfigByTypeKey(TEMPLATE_TYPE, key);
    if (template) {
      const duplicate = {
        ...template.value,
        name: `Copy of ${template.value.name}`,
      };
      return await createConfig(TEMPLATE_TYPE, duplicate);
    }
    return null;
  },
};

export default sharedTemplateService;
